<script>
  import { DateTime } from 'luxon';
	import { User } from '../store.js';
  import AutocompleteComponent from "../components/AutoCompleteComponent.svelte";
  import AutoCompleteMulti from "../components/AutoCompleteMulti.svelte";
  import Datepicker from 'svelte-calendar';

	export let params;
	export let dateRange;
	export let currentView;
	export let availability;
  export let propertiesListRequest;
  export let propertiesListView;
	export let columnSelected;
  export let searchTerm;
  export let dropdownSelected;
	export let emptyArray;

  let columnsFilter = [];
	let _dateRange = dateRange;
	let user;
	let values = {
		selectedCountry: '',
		selectedCity : '',
		selectedRegions : undefined,
		selectedTypes : undefined,
		propertyName : ''
	}

	const unUser = User.subscribe(v => user = v);
	const propertyClause = {isArchived:0,isActive:1};

	$: params = buildParms(values);
	$: dateRange, emptyArray=0;
	$: dateRange = limitRange(_dateRange);

	function initValues(){
		values = {
			selectedCountry: '',
			selectedCity : '',
			selectedRegions : [],
			selectedTypes : [],
			propertyName : ''
		};
		availability = 'all'
	}

	function limitRange(){
		const start = DateTime.fromJSDate(_dateRange.start);
		const end =  DateTime.fromJSDate(_dateRange.end);
		if(start > end && currentView === 0) _dateRange.end = start.plus({months : 1}).toJSDate();
		if(start > end && currentView === 1) _dateRange.end = start.plus({weeks : 1}).toJSDate();
		return _dateRange;
	}

	function buildParms(values){
		let _params = {};
		if(values.selectedCity){
			_params['city'] = values.selectedCity;
		}
		if(values.selectedCountry){
			_params['country'] = values.selectedCountry;
		} /*
		if(values.propertyName){
			_params['airbetterName'] = {contains : values.propertyName };
		}*/
		if(values.selectedProperties && values.selectedProperties.length){
			_params['airbetterName'] =  values.selectedProperties;
		}
		if(values.selectedRegions && values.selectedRegions.length){
			_params['region'] = values.selectedRegions;
		}
		if(values.selectedTypes && values.selectedTypes.length){
			_params['typeOfProperty'] = values.selectedTypes;
		}
		_params['isArchived'] = 0;
		_params['isActive'] =  1;
		return _params;
  }

	let options = [
    { id: 1, text: "All" },
    { id: 2, text: "Check-in" },
    { id: 3, text: "Check-out" },
  ]

  if( user.accountRole.toLowerCase() == "cleaner" ){
    columnsFilter = [
      { column: "all", columnOption: "All" },
      { column: "booking", columnOption: "Booking" },
      { column: "propertyName", columnOption: "Property Name" },
      { column: "airbetterName", columnOption: "Airbetter Name" },
      { column: "firstName", columnOption: "Guest First Name" },
      { column: "sureName", columnOption: "Guest Surename" },
      { column: "checkIn", columnOption: "Check In" },
      { column: "checkOut", columnOption: "Check Out" },
      { column: "nights", columnOption: "Nights" },
    ]
  }else{
    columnsFilter = [
      { column: "all", columnOption: "All" },
      { column: "booking", columnOption: "Booking" },
      { column: "transfer", columnOption: "Transfer" },
      { column: "propertyName", columnOption: "Property Name" },
      { column: "airbetterName", columnOption: "Airbetter Name" },
      { column: "firstName", columnOption: "Guest First Name" },
      { column: "sureName", columnOption: "Guest Surename" },
      { column: "checkIn", columnOption: "Check In" },
      { column: "checkOut", columnOption: "Check Out" },
      { column: "nights", columnOption: "Nights" },
      { column: "depositAmount", columnOption: "Deposit Amount" },
      { column: "depositCurrency", columnOption: "Deposit Currency" },
      { column: "depositStatus", columnOption: "Deposit Status" },
      { column: "sellRate", columnOption: "Sell Rate" },
      { column: "propertyCurrency", columnOption: "Property Currency" },
    ]
  }

	$: checkSelect = (selected) => {
    if( typeof selected == "number" && selected == 2 ){
      propertiesListRequest = propertiesListView.filter(x => x.type.includes("Checkin"));
    }else if( typeof selected == "number" && selected == 3 ){
      propertiesListRequest = propertiesListView.filter(x => x.type.includes("Checkout"));
    }else{
      propertiesListRequest = propertiesListView;
    }
  }

  $: columnMatches = (searchTerm, columnSelected) => {
    if( searchTerm && columnSelected){
      switch( columnSelected ) {
        case "all":
          propertiesListRequest = propertiesListView;
          break;
        case "booking":
          searchTerm = Number(searchTerm);
          propertiesListRequest = propertiesListView.filter(x => x.id !== null && [x.id].includes(searchTerm));
          break;
        case "transfer":
          searchTerm = Number(searchTerm);
          propertiesListRequest = propertiesListView.filter(x => x.originalReservationId !== null && [x.originalReservationId].includes(searchTerm));
          break;
        case "propertyName":
          propertiesListRequest = propertiesListView.filter(x => x.airbetterId.name !== null && x.airbetterId.name.toLowerCase().includes(searchTerm.toLowerCase()));
          break;
        case "airbetterName":
          propertiesListRequest = propertiesListView.filter(x => x.airbetterId.airbetterName !== null && x.airbetterId.airbetterName.toLowerCase().includes(searchTerm.toLowerCase()));
          break;
        case "firstName":
          propertiesListRequest = propertiesListView.filter(x => x.guestFirstName !== undefined && x.guestFirstName.toLowerCase().includes(searchTerm.toLowerCase()));
          break;
        case "sureName":
          propertiesListRequest = propertiesListView.filter(x => x.guestLastName !== undefined && x.guestLastName.toLowerCase().includes(searchTerm.toLowerCase()));
          break;
        case "checkIn":
          propertiesListRequest = propertiesListView.filter(x => x.dateFrom !== undefined && DateTime.fromISO(x.dateFrom).toLocaleString().includes(searchTerm));
          break;
        case "checkOut":
          propertiesListRequest = propertiesListView.filter(x => x.dateTo !== undefined && DateTime.fromISO(x.dateTo).toLocaleString().includes(searchTerm));
          break;
        case "nights":
          searchTerm = Number(searchTerm);
          propertiesListRequest = propertiesListView.filter(x => x.nights !== undefined && [x.nights].includes(searchTerm));
          break;
        case "depositAmount":
          searchTerm = Number(searchTerm);
          propertiesListRequest = propertiesListView.filter(x => x.securityDeposit[0] !== undefined && [x.securityDeposit[0].amount].includes(searchTerm));
          break;
        case "depositCurrency":
          propertiesListRequest = propertiesListView.filter(x => x.securityDeposit[0] !== undefined && x.securityDeposit[0].currency.toLowerCase().includes(searchTerm.toLowerCase()));
          break;
        case "depositStatus":
          if(searchTerm.toLowerCase() == "pending") {
            propertiesListRequest = propertiesListView.filter(x => x.securityDeposit[0] && x.securityDeposit[0].amountCollected == null);
          }else if(searchTerm.toLowerCase() == "collected"){
            propertiesListRequest = propertiesListView.filter(x => x.securityDeposit[0] && x.securityDeposit[0].amountCollected);
          }else{
            propertiesListRequest = [];
          }
          break;
        case "sellRate":
          searchTerm = Number(searchTerm);
          propertiesListRequest = propertiesListView.filter(x => x.sellRate !== null && [x.sellRate].includes(searchTerm));
          break;
        case "propertyCurrency":
          propertiesListRequest = propertiesListView.filter(x => x.airbetterId !== undefined && x.airbetterId.currency.toLowerCase().includes(searchTerm.toLowerCase()));
          break;
      }
    }
  }
</script>
<form on:submit|preventDefault>
	<input autocomplete="false" name="hidden" type="text" style="display:none;">
	{#if currentView !== 1}
		<section>
			<h4>Location</h4>
			<div class='row'>
				<div class='form-control'>
					<AutocompleteComponent node='region/country' placeholder="Country" bind:selected={values.selectedCountry} labelFieldName='country' valueFieldName='country' />
				</div>
				<div class='form-control'><AutocompleteComponent node='location' placeholder="City" bind:selected={values.selectedCity} labelFieldName='id' valueFieldName='id' /></div>
			</div >
			<div class='form-control'>
				<AutoCompleteMulti node='region' placeholder="Area" bind:selected={values.selectedRegions} labelFieldName='region' valueFieldName='region' />
			</div>
		</section>
		<section>
			<h4>Property Details</h4>
			<!-- <div class='form-control'><input type='text' name='PropertyName' placeholder='Property Name' bind:value={values.propertyName} /></div> -->
			<div class='form-control'>
				<AutoCompleteMulti node='property' placeholder="Property Name" bind:selected={values.selectedProperties} valueFieldName='airbetterName' labelFieldName='airbetterName' clause={propertyClause} />
			</div>
			<div class='form-control'><AutoCompleteMulti node='propertyType' placeholder="Property Type" bind:selected={values.selectedTypes} valueFieldName='name' labelFieldName='name' /></div>
			<div class='radio-selector'>
				<div class='radio-control'>
					<input bind:group={availability} type="radio" id="all-radio" name="availabilityRadio" value="all" >
					<label for="all-radio">All</label>
				</div>
				{#if user.accountRole.toLowerCase() !== 'cleaner'}
				<div class='radio-control'>
					<input bind:group={availability} type="radio" id="available-radio" name="availabilityRadio" value="available" >
					<label for="available-radio">Available</label>
					<span class='tip'>
					 	<p>Will show all properties for the requested date range where at least one night is available - useful when looking to relocate bookings in order to accommodate longer stays or when looking for stays with flexible arrival and departure dates.</p>
		            </span>
				</div>

				<div class='radio-control'>
					<input bind:group={availability} type="radio" id="full-available-radio" name="fullAvailabilityRadio" value="fullAvailable" >
					<label for="full-available-radio">Full Available</label>
					<span class='tip'>
					 	<p>Will only show properties that are available for the entire requested period to assist with specific reservations.</p>
		            </span>
				</div>
				{/if}
				<div class='radio-control'>
					<input bind:group={availability} type="radio" id="booked-radio" name="availabilityRadio" value="booked" >
					<label for="booked-radio">Booked</label>
					<span class='tip'>
					 	<p>Will show any properties that are booked for at least one night during the requested period.</p>
		            </span>
				</div>

				{#if user.accountRole.toLowerCase() !== 'cleaner'}
				<div class='radio-control'>
					<input bind:group={availability} type="radio" id="blocked-radio" name="availabilityRadio" value="blocked" >
					<label for="blocked-radio">Blocked</label>
					<span class='tip'>
					 	<p>Will show any properties blocked - blocks are grouped based on date/time of entry and common reason code.</p>
		            </span>
				</div>
				{/if}
			</div>
		</section>
		<section>
			<h4>Date Range</h4>
			<div class='row'>
				<Datepicker bind:selected={_dateRange.start} >
					<button class='date-picker-btn'>From: <span>{DateTime.fromJSDate(_dateRange.start).toLocaleString()}</span></button>
				</Datepicker>
				<Datepicker bind:selected={_dateRange.end} >
					<button class='date-picker-btn'>To : <span>{DateTime.fromJSDate(_dateRange.end).toLocaleString()}</span></button>
				</Datepicker>
			</div>
			<div class='form-control'>
				<button class='reset-btn' on:click={() => initValues()}>Reset</button>
			</div>
		</section>
	{:else if currentView === 1}
		<section class="filters-container">
			<div class="filters">
				<div class="input-filters" >
					<label for="checks">CI/CO:</label>
					<select bind:value={dropdownSelected} on:change={checkSelect(dropdownSelected)} id="checks">
						{#each options as option}
							<option value={option.id}>
								{option.text}
							</option>
						{/each}
					</select>
				</div>
			</div>
			<div class="filters">
				<div class="input-filters" >
					<label for="checks">Column:</label>
					<select bind:value={columnSelected} on:blur={columnMatches(searchTerm,columnSelected)}>
						{#each columnsFilter as column}
							<option value={column.column}>
								{column.columnOption}
							</option>
						{/each}
					</select>
				</div>
				<div class="input-filters" >
					<label for="checks">Search:</label>
					<input bind:value={searchTerm} on:input={columnMatches(searchTerm,columnSelected)} disabled={columnSelected=="all"}/>
				</div>
				<div class="input-filters button-container" >
					<button class="button" on:click={columnMatches(searchTerm,columnSelected)}>Search</button>
				</div>
			</div>
		</section>
		<section>
			<h4>Date Range</h4>
			<div class='row'>
				<Datepicker bind:selected={_dateRange.start} >
					<button class='date-picker-btn'>From: <span>{DateTime.fromJSDate(_dateRange.start).toLocaleString()}</span></button>
				</Datepicker>
				<Datepicker bind:selected={_dateRange.end} >
					<button class='date-picker-btn'>To : <span>{DateTime.fromJSDate(_dateRange.end).toLocaleString()}</span></button>
				</Datepicker>
			</div>
			<div class='form-control'>
				<button class='reset-btn' on:click={() => initValues()}>Reset</button>
			</div>
		</section>
	{/if}
</form>
<style>
	form{
		display: flex;
	    justify-content: space-between;
	    flex-wrap:wrap;
	    flex-grow: 1;
	    padding-right: 20px;
	}
	form section{
		flex: 1 1 0;
	}
	.form-control{
		margin:0 8px 8px 0;
		flex-grow: 1;
	}
	input{
		width: 100%;
		padding: 5px 11px;
		line-height: 24px;
	}

	.row{
		display: flex;
		flex-wrap: wrap;
	}
	.date-picker-btn{
		border: 1px solid #D0CFCB;
		width:100%;
		line-height: 22px;
		margin:0;
		text-align: left
	}
	.date-picker-btn span{
		color:#5FB3D5;
		font-weight:bold;
		margin-left:5px;
	}
	.radio-selector{
		display: flex;
		flex-wrap: wrap;
	}
	.radio-selector .radio-control{
		flex-grow: 1;
		font-size:12px;
		position: relative;
	}
	.radio-selector .radio-control input{
		width:auto;
		float: left;
	}
	.radio-control .tip {
		font-style: normal;
		text-transform: none;
		text-align: left;
		border: 1px solid #D0CFCB;
		background-color: white;
		position: absolute;
		padding: 10px;
		z-index: 5;
		display: none;
		width:300px;
		/*transform: translateX(-46%) translateY(-118%);*/
		color:black;
		font-size:13px;
		line-height:20px;
		font-weight:normal;
		left:-150px;
		bottom:30px;
	}
	.radio-control .tip p{
		margin:0;
	}

	.radio-control:hover .tip{
		display: block;
	}

	.radio-control .tip::before{
		width: 0;
		height: 0;
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
		border-top: 10px solid #D0CFCB;
		content: " ";
		position: absolute;
		bottom:-10px;
		left:150px;
	}

	.radio-control .tip::after{
		width: 0;
		height: 0;
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
		border-top: 9px solid white;
		content: " ";
		position: absolute;
		bottom:-8px;
		left:152px;
	}

	.reset-btn{
		background-color: #F4F3EF;
		color:#65625D;
		border: 1px solid #D0CFCB;
		width:100%;
		margin-top:8px;
		line-height: 21px;
	}
	.filters{
  margin-bottom: 1rem;
  margin-right: 3rem;
  display: inline-flex;
  flex-wrap: wrap;
}
	.input-filters{
	  display: inline-block;
	}
	input:disabled, button:disabled {
  	background: #ccc;
	}
	.filters-container{
	  display: -ms-inline-grid;
	  display: inline-grid;
	}
	.button{
	  background-color: #EF4064;
	  color: white;
	  font-weight: 600;
	  border-radius: 5px;
		height: 35px;
	}
	.filters select,input{
	  margin-right: 10px;
	}
	label{
	  margin: 5px 0;
	  font-weight: bold;
	}
	.button-container{
		display:flex;
		align-items: flex-end;
		margin-left: 10px;
	}
</style>